import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowUpRight, FileText, Loader2 } from 'lucide-react';
import { API, imageUrl } from '../lib/catalog';
import { Button } from '../components/ui/button';
import { PageIntro } from '../components/PageIntro';
import { BlurFade } from '../components/magicui/blur-fade';
import { BorderBeam } from '../components/magicui/border-beam';

export default function CatalogPage() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError(false);
    axios.get(`${API}/catalog/documents`, { signal: controller.signal })
      .then(r => setDocuments(r.data)).catch(e => { if (!axios.isCancel(e)) setError(true); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [attempt]);
  return <div className="premium-page">
    <div className="premium-container">
      <PageIntro title="Kolekcije na jednom mjestu." testId="catalog-title"><p data-testid="catalog-brand">Izvorni MAXLIGHT katalozi rasvjete.</p></PageIntro>
      {loading ? <Loader2 className="animate-spin" aria-label="Učitavanje kataloga" data-testid="catalog-documents-loading" />
        : error ? <div role="alert" data-testid="catalog-documents-error">Katalozi trenutno nisu dostupni. <Button variant="outline" onClick={() => setAttempt(attempt + 1)} data-testid="catalog-documents-retry">Pokušaj ponovo</Button></div>
        : <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {documents.map((doc, i) => <BlurFade key={doc.id} delay={i * 0.05}><a href={doc.url} target="_blank" rel="noopener noreferrer" className="premium-document" data-testid={`catalog-download-${doc.id}`}>
            <div className="premium-document-cover">{doc.image ? <img src={imageUrl(doc.image)} alt={doc.name} loading="lazy" data-testid={`catalog-cover-${doc.id}`} /> : <FileText className="w-full h-full text-gray-300" />}</div>
            <div className="p-6 border-t"><p className="text-[10px] text-gray-500 mb-2" data-testid={`catalog-format-${doc.id}`}>MAXLIGHT / PDF</p><h2 className="text-base md:text-lg font-medium mb-4" data-testid={`catalog-name-${doc.id}`}>{doc.name}</h2><span className="flex items-center justify-between gap-2 text-xs text-gray-600">Otvori katalog <ArrowUpRight size={16} /></span></div>
            {i === 0 && <BorderBeam duration={12} />}
          </a></BlurFade>)}
        </div>}
    </div>
  </div>;
}